(() => {
  const currentScript = document.currentScript;
  const bar = document.getElementById('floating-add-to-cart');

  if (!currentScript || !bar) return;

  const cssUrl = currentScript.dataset.css;
  const jsUrl = currentScript.dataset.js;
  let loaded = false;

  const loadStylesheet = () => {
    if (!cssUrl || document.querySelector(`link[href="${cssUrl}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    document.head.appendChild(link);
  };

  const loadScript = () => {
    if (!jsUrl || document.querySelector(`script[src="${jsUrl}"]`)) return;

    const script = document.createElement('script');
    script.src = jsUrl;
    script.defer = true;
    document.head.appendChild(script);
  };

  const loadFloatingAddToCart = () => {
    if (loaded) return;
    loaded = true;
    cleanup();
    loadStylesheet();
    loadScript();
  };

  const events = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
  const options = { once: true, passive: true };

  function cleanup() {
    events.forEach((eventName) => window.removeEventListener(eventName, loadFloatingAddToCart, options));
  }

  events.forEach((eventName) => window.addEventListener(eventName, loadFloatingAddToCart, options));

  if (window.Shopify?.designMode) {
    loadFloatingAddToCart();
  }
})();
